import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { SERVICES } from "../data/site";

export default function Servizi() {
  return (
    <>
      <PageHeader
        eyebrow="Servizi"
        title="Tutto ciò che serve, in un unico cantiere."
        description="Dalle opere stradali al civile fino agli interventi specialistici: un partner completo per enti pubblici, aziende e privati."
      />

      <section data-reveal className="py-16 md:py-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 space-y-[1px] bg-neutral-200 border border-neutral-200">
          {SERVICES.map((s, idx) => (
            <Link
              to={`/servizi/${s.slug}`}
              key={s.slug}
              data-testid={`servizi-card-${s.slug}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-0 bg-white hover:bg-[#0B1E3F] transition-colors rounded-3xl border border-neutral-200 overflow-hidden"
            >
              <div className="md:col-span-5 relative aspect-[4/3] md:aspect-auto overflow-hidden min-h-[260px]">
                <img src={s.image} alt={s.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="md:col-span-7 p-8 md:p-12 flex flex-col justify-between">
                <div className="flex items-start justify-between">
                  <div className="font-mono text-xs tracking-[0.25em] uppercase text-[#1D4ED8] group-hover:text-[#60A5FA]">
                    / {s.number}
                  </div>
                  <ArrowUpRight className="w-6 h-6 text-[#0B1E3F] group-hover:text-[#60A5FA] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
                </div>
                <div className="mt-8">
                  <h3 className="font-display font-black uppercase tracking-tighter text-4xl md:text-5xl lg:text-6xl mb-6 group-hover:text-white transition-colors">
                    {s.title}
                  </h3>
                  <p className="text-lg text-neutral-600 group-hover:text-neutral-300 max-w-2xl leading-relaxed">
                    {s.description}
                  </p>
                  <div className="mt-6 flex flex-wrap gap-2">
                    {s.offerings.slice(0, 3).map((o, i) => (
                      <span
                        key={i}
                        className="font-mono text-[10px] tracking-[0.15em] uppercase text-neutral-500 group-hover:text-neutral-400 border border-neutral-300 group-hover:border-neutral-700 px-3 py-1 rounded-full"
                      >
                        {o}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
